export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Včera"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dnes"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pondělí"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úterý"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Středa"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Čtvrtek"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pátek"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sobota"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neděle"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ledna"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["února"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["března"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dubna"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["května"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["června"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["července"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["srpna"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["září"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["října"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["listopadu"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["prosince"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vy"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrátor"])}
}